export default [
    // members sidebar index route
    {
        path: '/devices',
        component: () => import(/* webpackChunkName: "residents-index" */ '@/views/devices/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'devices.index',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/devices/list.vue'),
                meta: {
                    layout: 'dashboard'
                }
            },
            {
                path: 'activate',
                name: 'devices.activate',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/devices/activate.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
